import { shouldSkipNewRelicAgent } from './utils/newRelicGuard';
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ensureMaterialSymbolsReady } from './utils/materialSymbols';
import { nreumPageAction } from './utils/perfTelemetry';

ensureMaterialSymbolsReady();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// web-vitals + NR SPA PerformanceObserver is what throws reportAllChanges/startTime.
if (!shouldSkipNewRelicAgent(window.location.hostname)) {
  reportWebVitals((metric) => {
    nreumPageAction("web-vital", {
      name: metric.name,
      value: metric.value,
      id: metric.id,
      rating: (metric as unknown as { rating?: string }).rating || "unknown",
    });
  });
}
